import { useWorkflows, workflowSelector } from '@/store/workflows';
import { NodeShell } from '../NodeShell';
import type { NodeProps } from '@xyflow/react';
import clsx from 'clsx';

export function GateNode({ data }: NodeProps & { data: { workflowId: string } }) {
  const wf = useWorkflows(workflowSelector(data.workflowId));
  const setAutoUpload = useWorkflows((s) => s.setAutoUpload);
  const setPendingReview = useWorkflows((s) => s.setPendingReview);
  if (!wf) return null;

  const topSlot = (
    <div className="inline-flex items-center gap-2 rounded-full border border-ink-800 bg-ink-900 px-2 py-1 text-[10px] uppercase tracking-[0.14em]">
      <button
        className={clsx(
          'rounded-full px-2 py-0.5 transition-colors',
          !wf.autoUpload ? 'bg-ink-800 text-ink-200' : 'text-ink-500 hover:text-ink-300'
        )}
        onClick={() => setAutoUpload(wf.id, false)}
      >manual</button>
      <button
        className={clsx(
          'rounded-full px-2 py-0.5 transition-colors',
          wf.autoUpload ? 'bg-signal-on text-ink-950' : 'text-ink-500 hover:text-ink-300'
        )}
        onClick={() => setAutoUpload(wf.id, true)}
      >auto</button>
    </div>
  );

  return (
    <NodeShell title="Review & Upload" state={wf.states.gate} width={220} topSlot={topSlot}>
      {wf.pendingReview ? (
        <button
          className="w-full text-xs px-2 py-1.5 rounded-md bg-accent-500 hover:bg-accent-400 text-ink-950 font-medium"
          onClick={() => setPendingReview(wf.id, wf.pendingReview)}
        >open review</button>
      ) : (
        <div className="text-[11px] text-ink-500">
          {wf.autoUpload ? 'auto-publish on edit done' : 'pause for human approval'}
        </div>
      )}
    </NodeShell>
  );
}
